<template>
    <div v-if="isreadshow">    
        <my-form  table>
            <span style="color:red;font-size:16px;">当前报价得分依据“总价”计算。</span>
            <my-form-item-group title="计算报价得分">                  
                <my-table :data="bidderList" :height="tableHeight" v-if="type === 'node'" v-model="tableSelect">
                    <el-table-column   type="selection" width="55" fixed></el-table-column>
                    <el-table-column label="投标人" prop="tbdwname"></el-table-column>
                    <el-table-column label="投标报价" prop="tbdwbj"></el-table-column>
                    <el-table-column label="基准价" prop="baseprice"></el-table-column>
                    <el-table-column label="报价得分" prop="score" fixed="right"></el-table-column>              
                </my-table>
                <my-table :data="bidderList" :height="tableHeight" v-if="type === 'total'" v-model="tableSelect">
                    <el-table-column   type="selection" width="55" fixed></el-table-column>
                    <el-table-column label="投标人" prop="tbdwname"></el-table-column>
                    <el-table-column label="总分" prop="score"  fixed="right"></el-table-column>              
                </my-table>
            </my-form-item-group>
            <template slot="btn" class="btn">
                <el-button type="success" v-if="type==='node'" @click="fSave()">计算报价得分</el-button>
                <el-button type="success" v-if="type==='total'"  @click="fSavetotal()">计算总分</el-button>
                <el-button type="primary" v-if="type==='total'" @click="reload()">重置</el-button>  
            </template>
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page';
import selectnode from './selectnode';
export default {
    mixins: [LIST_PAGE_MIXIN],
    components:{
        selectnode
    },
    data() {
        return{
            type:'',
            isreadshow:true,
            tableSelect:[],
            bidderList:[],
            nodeKeyJsonStr:''
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        backlc:function(){
            this.$router.push({
                path:'/bidding/liucheng/index',
                query:{
                    id:this.$route.query.procode
                }
            })
        },
        //重置
        reload:function(){
            var that = this;
            this.isreadshow=false;
            that.$nextTick(function(){
                that.isreadshow=true;
            })
            this.tableSelect=[];
            if(this.$route.query.offerscoreKey!=undefined){
                that.$get(`${this.getGetters('bidUrl')}/KaiBiao/getoffer/selecttbdw.json`,
                {bdcode:this.$route.query.bdcode,procode:this.$route.query.procode,type:this.$route.query.type,basepriceKey:this.$route.query.basepriceKey,
                offerscoreKey:this.$route.query.offerscoreKey,mxnodekey:this.$route.query.mxnodekey,name:this.$route.query.name},(data, res) => {
                    that.bidderList=JSON.parse(data.bidderList)
                    if(data.bidderList=='[]'){
                        ShowMsg('暂无信息','error');
                    }
                    this.nodeKeyJsonStr=data.nodeKeyJsonStr 
                });
            }else{
                that.$get(`${this.getGetters('bidUrl')}/KaiBiao/getoffer/selecttbdw.json`,{bdcode:this.$route.query.bdcode,procode:this.$route.query.procode,
                type:this.$route.query.type},(data, res) => {
                    that.bidderList=JSON.parse(data.bidderList)
                });
            }
        },
        //计算报价得分
        fSave:function(){
            var that =this
            this.bidderList.forEach(function (x) {
                x.score = '';
                x.baseprice = '';
            })
            if(this.tableSelect==''){
                ShowMsgBox('请选择投标人','warning');
            }else{
                that.$post(`${this.getGetters('bidUrl')}/KaiBiao/getoffer/getofferscore.json`,{bdcode:this.$route.query.bdcode,
                bidderListJsonStr:JSON.stringify(this.tableSelect),nodeKeyJsonStr:this.nodeKeyJsonStr}, (res, data) => {
                    if(data.result) {
                        var resultList = data.t;
                        resultList.forEach(function (item) {
                            var returnTbdwcode = item.tbdwcode;
                            that.bidderList.forEach(function (x) {
                                if(returnTbdwcode==x.tbdwcode) {
                                    x.baseprice = item.baseprice;
                                    x.score = item.score;
                                }else {

                                }
                            })
                            // that.bidderList = resultList;
                        })
                    } else {
                        ShowMsg(data.msg,'error');
                    }
                });
            }
        },
        //计算总分
        fSavetotal:function(){
            var that =this
            this.bidderList.forEach(function (x) {
                x.score = '';
            })
            if(this.tableSelect==''){
                ShowMsgBox('请选择投标人','warning');
            }else{
                that.$post(`${this.getGetters('bidUrl')}/KaiBiao/getoffer/getofferscoretotal.json`,{bdcode:this.$route.query.bdcode,
                bidderListJsonStr:JSON.stringify(this.tableSelect)}, (res,data) => {
                    if(data.result) {
                        var resultList = data.t;
                        resultList.forEach(function (item) {
                            item.score = item.sumscore;
                             var returnTbdwcode = item.tbdwcode;
                            that.bidderList.forEach(function (x) {
                                if(returnTbdwcode==x.tbdwcode) {
                                    item.tbdwname = x.tbdwname
                                }else {

                                }
                            })
                            that.bidderList = resultList;
                        })
                    } else {
                        ShowMsg(data.msg,'error');
                    }
                });
            }
        }
    },
    created() {
        this.type=this.$route.query.type
    },
    mounted() {
        var that=this
        if(this.$route.query.offerscoreKey!=undefined){
            that.$get(`${this.getGetters('bidUrl')}/KaiBiao/getoffer/selecttbdw.json`,
            {bdcode:this.$route.query.bdcode,procode:this.$route.query.procode,type:this.$route.query.type,basepriceKey:this.$route.query.basepriceKey,
            offerscoreKey:this.$route.query.offerscoreKey,mxnodekey:this.$route.query.mxnodekey,name:this.$route.query.name},(data, res) => {
                that.bidderList=JSON.parse(data.bidderList)
                if(data.bidderList=='[]'){
                    ShowMsg('暂无信息','error');
                }
                this.nodeKeyJsonStr=data.nodeKeyJsonStr 
            });
        }else{
            that.$get(`${this.getGetters('bidUrl')}/KaiBiao/getoffer/selecttbdw.json`,{bdcode:this.$route.query.bdcode,procode:this.$route.query.procode,
            type:this.$route.query.type},(data, res) => {
                that.bidderList=JSON.parse(data.bidderList)
            });
        }

    }
}
</script>

<style scoped lang="scss">

</style>
